// extracted by mini-css-extract-plugin
export default {"item":"SelectedMenuItem-item-q3JrL","isSelected":"SelectedMenuItem-isSelected-tocvz","isNotSelected":"SelectedMenuItem-isNotSelected-UNRlj"};